import { EntityIdAliasPrefixes } from '@abb-procure/constants';
import { DocumentsApiService } from '@abb-procure/data';
import { SnackbarService } from '@abb-procure/snackbar';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';
import { AIBadge } from '../ai-badge/ai-badge.component';

@Component({
  selector: 'procure-document-processing-menu-item',
  templateUrl: './document-processing-menu-item.component.html',
  imports: [MatMenuItem, AIBadge],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentProcessingMenuItem {
  readonly id = input.required<string>();
  readonly entityType = input.required<EntityIdAliasPrefixes>();

  private readonly documentsApiService = inject(DocumentsApiService);
  private readonly snackbarService = inject(SnackbarService);

  protected async triggerDocumentProcessing(): Promise<void> {
    const response = await this.documentsApiService.triggerDocumentProcessing(
      this.entityType(),
      this.id(),
    );

    if (!response) {
      return;
    }

    this.snackbarService.showInfoSnackbar({
      text: 'Your request has been added to the queue. The documents will be processed shortly.',
    });
  }
}
